(function () {
  'use strict';

  angular.module('student.plan.rules.header', ['sis-components.planRange', 'pascalprecht.translate', 'student.shared']);
})();